import { isoCountries } from "/assets/js/src/themes/utils/isocountries";
import $ from "jquery";

const formCountryPhoneNumber = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const el = {
      select: ".js-CountryCode",
      telephone: ".CustomizerFormCustomContent__Body #telefoonummer",
      countryCode: ".CustomizerFormCustomContent__Body #countryCode",
    };

    if ($(el.select).length === 0) return;

    function formatCountry(country) {
      if (!country.id) return country.name;
      let $country = $(
        `<span class="flag-icon flag-icon-${country.text.split("---")[1].toLowerCase()} flag-icon-squared"></span>
        <span class="flag-text" style="margin-left:10px">${country.text.split("---")[0]} (${
          country.id
        })</span>`
      );
      return $country;
    }

    function formatCountrySelection(country) {
      return country.id;
    }

    $(el.countryCode).select2({
      placeholder: "Select a country",
      templateResult: formatCountry,
      templateSelection: formatCountrySelection,
      data: isoCountries.map((_) => ({id: _.id, text: `${_.name}---${_.code}`})),
      dropdownCssClass: "dropdownMaxContent",
      dropdownAutoWidth: true,
    });

    // Set the default value programmatically
    $(el.countryCode).val('+31').trigger('change');
  };

  init();
};

try {
  formCountryPhoneNumber();
} catch (error) {
  console.error("formCountryPhoneNumber", error);
}
